import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Controller, useForm } from "react-hook-form";
import { Message } from "primereact/message";
import Select from "react-select";
import { confirmDialog } from "primereact/confirmdialog";
import { useState } from "react";
import { useAxios, API_URL } from "../../../utils/const";
import toast from "react-hot-toast";

const RestoreModal = ({ visible, onHide, backups }) => {
  const form = useForm({
    defaultValues: {
      discount_type: { value: 1, label: "Percentage" },
    },
  });
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
  } = form;
  const [isLoading, setIsLoading] = useState(false);
  const axiosInstance = useAxios();

  const confirmRestore = () => {
    confirmDialog({
      message:
        "Anda akan mengembalikan data dari backup yang dipilih. Semua perubahan terbaru mungkin akan ditimpa. Lanjutkan?",
      header: "Konfirmasi",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: handleSubmit(onSubmit),
    });
  };

  const onSubmit = async (formData) => {
    setIsLoading(true);
    const data = {
      filename: formData.backupFile.value,
    };
    try {
      await axiosInstance.post(`${API_URL}/backups/restore`, data);
      toast.success("Backup data berhasil dibuat dan disimpan.!");
      setIsLoading(false);
      onReset();
      onHide();
    } catch (error) {
      toast.error(
        error.response?.data?.msg || error.message || "Failed to restore."
      );
      setIsLoading(false);
    }
  };

  const backupFileOption =
    backups?.map((backups) => ({
      value: backups,
      label: backups,
    })) || [];

  const onReset = () => {
    reset(Object.fromEntries(Object.keys(watch()).map((key) => [key, ""])));
  };

  return (
    <Dialog
      header="Restore"
      visible={visible}
      style={{ width: "40vw" }}
      onHide={onHide}
      modal
      footer={
        <div>
          <Button
            label="Batal"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text"
          />
          <Button
            label={isLoading ? "Restoring..." : "Restore"}
            icon="pi pi-check"
            className="rounded"
            // onClick={handleSubmit(onSubmit)}
            onClick={() => confirmRestore()}
            disabled={isLoading}
          />
        </div>
      }
    >
      <div className="p-fluid mb-2">
        <label>Select File</label>
        <Controller
          control={control}
          name="backupFile"
          rules={{ required: "Pilih salah satu" }}
          render={({ field }) => (
            <Select
              options={backupFileOption}
              value={field.value}
              onChange={(value) => field.onChange(value)}
            />
          )}
        />
        {errors.backupFile && (
          <Message
            className="mt-2 d-flex"
            severity="error"
            text={errors.backupFile.message}
          />
        )}
      </div>
    </Dialog>
  );
};

export default RestoreModal;
